import { useMemo } from 'react';

export const ZERO_EMISSION_POWER_PLANT_TYPES = ['Battery Electric Vehicle (BEV)', 'Fuel Cell Electric Vehicle (FCEV)'];

type UseEffectiveCO2EmissionsParams = {
  powerplanttype: string | null;
  co2combined: number | null;
};

/**
 * React hook that determines effective CO2 emissions based on power plant type.
 * Returns 0 for zero-emission vehicles (BEV, FCEV) regardless of the co2combined value.
 * For all other vehicles, returns the original co2combined value.
 */
export const useEffectiveCO2Emissions = ({
  powerplanttype,
  co2combined,
}: UseEffectiveCO2EmissionsParams): number | null => {
  return useMemo(() => {
    if (powerplanttype && ZERO_EMISSION_POWER_PLANT_TYPES.includes(powerplanttype)) {
      return 0;
    }

    return co2combined;
  }, [powerplanttype, co2combined]);
};
